import { Component, signal } from '@angular/core';
import { NavigationService } from '../../../../../services/navigation.service';
import { SetupWizardState, SetupWizardSteps } from '@mira-avant/mtlibs';
import { ZorroModule } from '../../../../../modules/zorro.module';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-setup-wizard-dashboard',
	imports: [ZorroModule],
	standalone: true,
	templateUrl: './setup-wizard-dashboard.html',
	styleUrl: './setup-wizard-dashboard.scss',
})
export class SetupWizardDashboard {
	public SetupWizardState = SetupWizardState;
	public selectedSteps: SetupWizardSteps[] = [];
	public clientUuid = signal<string | undefined>(undefined);
	private sub?: Subscription;

	constructor(
		private route: ActivatedRoute,
		public nav: NavigationService
	) {
		this.sub = this.route.params.subscribe(params => {
			this.clientUuid.set(params['clientUuid']);
		});
	}

	async ngOnInit() {
		const clientUuid = this.clientUuid();

		if (!clientUuid) {
			throw new Error('Client UUID is not defined');
		}
	}

	public onStepsChange(steps: SetupWizardSteps[]) {
		this.selectedSteps = steps;
	}

	ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}
	}
}
